import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=adabfbca&"
import script from "./Templates.vue?vue&type=script&lang=js&"
export * from "./Templates.vue?vue&type=script&lang=js&"
import style0 from "./Templates.vue?vue&type=style&index=0&id=adabfbca&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adabfbca')) {
      api.createRecord('adabfbca', component.options)
    } else {
      api.reload('adabfbca', component.options)
    }
    module.hot.accept("./Templates.vue?vue&type=template&id=adabfbca&", function () {
      api.rerender('adabfbca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/notifications/Templates.vue"
export default component.exports